import { render, staticRenderFns } from "./BillingBilling.vue?vue&type=template&id=aa87cdb4"
import script from "./BillingBilling.vue?vue&type=script&lang=js"
export * from "./BillingBilling.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports